module.exports = __webpack_public_path__ + "yellowtail-regular.0b7fc49af6e94ea3d620.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/other/yellowtail-regular.ttf
// module id = ../../../../../src/assets/fonts/other/yellowtail-regular.ttf
// module chunks = styles